import { render } from "./VideoChapters.vue?vue&type=template&id=55c0ee21"
import script from "./VideoChapters.vue?vue&type=script&lang=js"
export * from "./VideoChapters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__